<app-expiration-message></app-expiration-message> <router-outlet></router-outlet>
